import React from "react";
import { Odometer } from "../Odometer/Odometer";
import overviewRightBg from "../../assets/img/overview/overview_right_bg.png";
import overviewMain from "../../assets/img/overview/overview_main.png";
import overviewSmall from "../../assets/img/overview/overview_small.png";
import overviewAnimation from "../../assets/img/overview/overview_animation.png";

export const OverviewAreaOne = () => {
  const steps = [
    "Book a free 20-minute health check",
    "Get a fixed monthly quote, with no hourly billing",
    "We set up your software and connect your bank",
    "You snap receipts; we close your books by the 15th",
  ];

  return (
    <section className="overview-area pt-120 pb-120">
      <div
        className="overview-shape"
        data-aos="fade-left"
        data-aos-delay="200"
        style={{ backgroundImage: `url(${overviewRightBg})` }}
      ></div>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="overview-img-wrap">
              <img src={overviewMain} alt="" />
              <img src={overviewSmall} alt="" data-parallax='{"x" : 50 }' />
              <img src={overviewAnimation} alt="" />
              <div className="icon">
                <i className="flaticon-report-1"></i>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="overview-content">
              <div className="section-title-two mb-20 tg-heading-subheading animation-style3">
                <span className="sub-title">How it Works</span>
                <h2 className="title tg-element-title">
                The Easiest Way to Get Your Books Done
                </h2>
              </div>
              <p className="info-one">
              The easiest way to handle bookkeeping is to separate your business and personal money, use one accounting software, and let a bookkeeper do the monthly work. With Silverwave it takes four steps:
              </p>

              <div className="about-list-two mb-30">
                <ul className="list-wrap">
                  {steps.map((item, idx) => (
                    <li key={idx}>
                      <i className="fas fa-arrow-right"></i> {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="content-bottom">
                <ul className="list-wrap">
                  <li>
                    <div className="icon">
                      <i className="flaticon-trophy"></i>
                    </div>
                    <div className="content">
                      <h2 className="count">
                        <Odometer end={15} />+
                      </h2>
                      <p>Books closed every month</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i className="flaticon-rating"></i>
                    </div>
                    <div className="content">
                      <h2 className="count">
                        <Odometer end={20} />min
                      </h2>
                      <p>Free Check</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
